function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export function addCommas(nStr) {
  nStr += '';
  var x = nStr.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }

  return x1 + x2;
}
export function hFormatter(num, digits) {
  var si = [{
    value: 1e-3,
    symbol: 'Hz'
  }, {
    value: 1,
    symbol: 'KHz'
  }, {
    value: 1e3,
    symbol: ' MHz'
  }, {
    value: 1e6,
    symbol: ' GHz'
  }, {
    value: 1e9,
    symbol: ' THz'
  }, {
    value: 1e12,
    symbol: ' PHz'
  }, {
    value: 1e15,
    symbol: ' EHz'
  }, {
    value: 1e18,
    symbol: ' ZHz'
  }, {
    value: 1e21,
    symbol: ' YHz'
  }];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;

  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}
export function hAxisFormatter(num, digits) {
  var si = [{
    value: 10e2,
    symbol: 'Hz'
  }, {
    value: 10e3,
    symbol: 'KHz'
  }, {
    value: 10e6,
    symbol: ' MHz'
  }, {
    value: 10e9,
    symbol: ' GHz'
  }, {
    value: 10e12,
    symbol: ' THz'
  }, {
    value: 10e15,
    symbol: ' PHz'
  }, {
    value: 10e18,
    symbol: ' EHz'
  }, {
    value: 10e21,
    symbol: ' ZHz'
  }, {
    value: 10e24,
    symbol: ' YHz'
  }];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;

  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}
export function selectData(data, type, index) {
  if (type == 'bands') {
    return [].concat(_toConsumableArray(data.spectrumOutline.map(function (d) {
      d.group = 'outline';
      d.state = index == 0 ? 'active' : 'inactive';
      return d;
    })), _toConsumableArray(data.spectrumBands.map(function (d) {
      d.group = 'bands';
      d.state = index >= 1 ? 'active' : 'inactive';
      return d;
    })));
  }

  return [].concat(_toConsumableArray(data.nestedData.map(function (d) {
    d.group = 'nested'; // d.state = (index <= 1) ? 'active' : 'inactive';

    return d;
  })), _toConsumableArray(data.auctionBands.map(function (d) {
    d.group = 'auction'; // d.state = (index >= 2) ? 'active' : 'inactive';

    return d;
  })));
}
export function getCoords(event) {
  return {
    px: event.clientX || event.touches[0].clientX,
    py: event.clientY || event.touches[0].clientY
  };
}
export function getInsetData(domain) {
  return [{
    key: 'insetBand',
    label: '',
    start: 20 * 10e3,
    end: 10e12 * 0.3
  }];
}
export var groups = [{
  label: 'INTER SATELLITE',
  class: 'inter',
  name: 'Inter-satellite'
}, {
  label: 'EARTH EXPLORATION',
  class: 'earth',
  name: 'Earth exploration'
}, {
  label: 'SPACE',
  class: 'space',
  name: 'Space'
}, {
  label: 'MARITIME',
  class: 'maritime',
  name: 'Maritime'
}, {
  label: 'BROADCASTING',
  class: 'broadcast',
  name: 'Broadcasting'
}, {
  label: 'MOBILE',
  class: 'mobile',
  name: 'Mobile'
}, {
  label: 'AERONAUTICAL',
  class: 'aero',
  name: 'Aeronautical'
}, {
  label: 'AMATEUR',
  class: 'amateur',
  name: 'Amateur'
}, {
  label: 'STANDARD FREQUENCY AND TIME SIGNAL',
  class: 'time',
  name: 'Time and frequency standardization'
}, {
  label: 'FIXED',
  class: 'fixed',
  name: 'Fixed'
}, {
  label: 'RADIO',
  class: 'radio',
  name: 'Radio navigation and location'
}, {
  label: 'METEOROLOGICAL',
  class: 'metero',
  name: 'Climate and weather'
}];
export function getSpectrumData(data) {
  //sort the groups by category
  var g = JSON.parse(JSON.stringify(groups));
  var nested = data.filter(function (d) {
    return d.group == 'nested';
  });
  g.forEach(function (d) {
    d.blocks = mergeNeighbors(nested.filter(function (row) {
      return row.mergedKeys.filter(function (k) {
        return k == d.label;
      }).length > 0;
    }));
    d.totalRange = 0;
    d.blocks.forEach(function (b) {
      if (b.start < 100000000) {
        var end = b.end > 100000000 ? 100000000 : b.end;
        d.totalRange += end - b.start;
      }
    });
  });
  g.sort(function (a, b) {
    return a.totalRange - b.totalRange;
  }); //band type

  var bands = data.filter(function (d) {
    return d.group == 'nested';
  });
  var fed = [];
  var shared = [];
  var commercial = [];
  bands.forEach(function (d) {
    var isFed = d.fed.length > 0 ? true : false;
    var isNonFed = d.nonFed.length > 0 ? true : false;

    if (isFed && isNonFed) {
      d.control = 'shared';
      shared.push(d);
    } else if (isFed) {
      d.control = 'fed';
      fed.push(d);
    } else if (isNonFed) {
      d.control = 'nonfed';
      commercial.push(d);
    }
  });
  fed = mergeNeighbors(fed);
  shared = mergeNeighbors(shared);
  commercial = mergeNeighbors(commercial);
  return {
    groups: g,
    control: [].concat(_toConsumableArray(fed), _toConsumableArray(shared)),
    auction: data.filter(function (d) {
      return d.group == 'auction';
    })
  };
}

function mergeNeighbors(data) {
  var final = [];
  data.forEach(function (d) {
    if (final.length > 0) {
      var prev = final[final.length - 1];

      if (d.start == prev.end && d.type == prev.type) {
        prev.end = d.end;
        prev.status = 'merged';
        final[final.length - 1] = prev;
      } else {
        final.push(_objectSpread({}, d));
      }
    } else {
      final.push(_objectSpread({}, d));
    }
  }); // console.log('start', data)
  // console.log('end', final)

  return final;
}